import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationTofuWorkspaceUnlockArgs, TofuWorkspace } from "types/generated";

type UnlockTofuWorkspaceData = {
  tofuWorkspaceUnlock: Pick<TofuWorkspace, "id" | "name" | "isLocked">;
};

export const TOFU_WORKSPACE_UNLOCK: TypedDocumentNode<
  UnlockTofuWorkspaceData,
  MutationTofuWorkspaceUnlockArgs
> = gql`
  mutation TofuWorkspaceUnlock($id: ID!) {
    tofuWorkspaceUnlock(id: $id) {
      id
      name
      isLocked
    }
  }
`;
